function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null);

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  fill: "#85a0bb",
  id: "Core",
  transform: "translate(-260.000000, -90.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "chevron-right",
  transform: "translate(260.500000, 90.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0 L-0.4,1.4 L4.2,6 L-0.4,10.6 L1,12 L7,6 L1,0 Z",
  id: "Shape"
}))));

var SvgIconfinderChevronRight = function SvgIconfinderChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "12px",
    viewBox: "0 0 9 12",
    width: "9px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconfinderChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconfinder_chevron-right.4d2604a4.svg";
export { ForwardRef as ReactComponent };